import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import React from "react";
import { SidePanelFreeFieldPermissionsSection } from "./SidePanelFreeFieldPermissionsSection";

interface FreeFieldPermissionProfileSidePanelDetailsProps {
  data: server.dto.FreeFieldProfileSidePanelData
  environment: server.dto.Environments
}

const getTitle = (mainArea: server.dto.MainAreas) => {
  switch (mainArea) {
    case "show":
      return site.currentEnvironment.show.singular;
    case "tour":
      return site.currentEnvironment.tour.singular;
    default:
      return "";
  }
}

export const FreeFieldPermissionProfileSidePanelDetails = (props: FreeFieldPermissionProfileSidePanelDetailsProps) => {
  const { freeFields, permissions, profile } = props.data;

  const environmentTypeTitle = profile.environment === "internal"
    ? RESX.UserType.InternalUsers
    : RESX.UserType.ExternalUsers;

  return <SidePanelDetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    sections={[{
      key: "freeFieldPermissionProfile",
      type: "regular",
      hideTitle: true,
      title: RESX.FreeField.FreeFieldPermissionProfile,
      fields: [{
        key: "name",
        label: RESX.GeneralLabels.Name,
        render: () => <span>{profile.title}</span>
      }, {
        key: "type",
        label: RESX.GeneralLabels.Type,
        render: () => <span>{environmentTypeTitle}</span>
      }]
    }]}
    additionalContent={<>
      {freeFields.map(freeFieldArea => <div key={freeFieldArea.mainArea} className="flex-column gap side-panel-free-field-permissions-area">
        <h4>{getTitle(freeFieldArea.mainArea)}</h4>
        <SidePanelFreeFieldPermissionsSection
          environment={props.environment}
          categories={freeFieldArea.categories}
          permissions={permissions}
        />
      </div>)}
    </>}
  />
}